










import { namespace } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import { CART } from '@/store/types';
import ProductSection from '@/cart-page/cart/section/ProductSection.vue';

const cart = namespace(CART);

@Component({
  components: {
    ProductSection
  }
})
export default class FairCartStepView extends Vue {}
